import i18n from '~/components/i18n'

export const dynamicOffersPreviewColumns = () => ([
  {
    name: i18n.t('Trading month'),
    key: 'date',
    type: 'dateRibbon',
    format: 'MMM YYYY'
  },
  {
    name: i18n.t('Fat price (€/100kg)'),
    key: 'fatPrice',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Protein price (€/100kg)'),
    key: 'proteinPrice',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Fixed price (€/100kg)'),
    key: 'price',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Offered amount (in kg)'),
    key: 'offeredAmount',
    type: 'no-unit-number',
    decimalScale: 0
  },
  {
    name: i18n.t('Confirmed trading amount (in kg / in %)'),
    key: 'confirmedAmount',
    type: 'confirm-fat-protein'
  },
  {
    name: i18n.t('Actions'),
    type: 'action'
  }
])

export const dynamicConfirmOffersColumns = () => ([
  {
    name: i18n.t('Trading month'),
    key: 'date',
    type: 'dateRibbon',
    format: 'MMM YYYY'
  },
  {
    name: i18n.t('Offered amount (in kg)'),
    key: 'offeredAmount',
    type: 'number'
  },
  {
    name: i18n.t('Confirmed trading amount (in kg / in %)'),
    key: 'confirmedAmount',
    type: 'confirm-fat-protein'
  }
])

export const dynamicParticipientFarmersColumns = () => [
  {
    name: i18n.t('Farmer'),
    key: 'companyName'
  },
  {
    name: i18n.t('Offer ID'),
    key: 'uniqueId'
  },
  {
    name: i18n.t('Offer date'),
    key: 'createdAt',
    type: 'date',
    format: ('DD.MM.YYYY HH:mm')
  },
  {
    name: i18n.t('Status'),
    key: 'statusLabel'
  },
  {
    name: i18n.t('Offered amount (in kg)'),
    key: 'amount',
    type: 'number'
  },
  {
    name: i18n.t('Confirmed trading amount (in kg / in %)'),
    type: 'confirm'
  }
]

export const actions = [
  {
    popupMessage: i18n.t('Enter confirmed amount'),
    type: 'icon',
    name: 'handshake outline',
    size: 'large',
    actionType: 'enterConfirmed'
  },
  {
    popupMessage: i18n.t('Participated farmers'),
    type: 'icon',
    name: 'group',
    size: 'large',
    actionType: 'participated'
  }
]

export const actionsForLightUser = [
  {
    popupMessage: i18n.t('Participated farmers'),
    type: 'icon',
    name: 'group',
    size: 'large',
    actionType: 'participated'
  }
]

export const actionsForOperative = [
  {
    popupMessage: i18n.t('Enter confirmed amount'),
    type: 'icon',
    name: 'handshake outline',
    size: 'large',
    actionType: 'enterConfirmed'
  }
]